/**
 * @desc: - 选择投注mode
 * @param  {[STRING]} value:        [当前选中值]
 * @param  {[FUNCTION]} onChange:   [点击变更值]
 * @author: circle
 */
export default class SelectTimes extends React.Component {

  constructor(props) {
    super(props);
  }
  // 输入变更
  handleOnchange(index) {
    const { onChange, id, num, rate} = this.props;
    let times = document.getElementById("inputValue"+index).value.replace(/[^0-9]/g,"").substring(0,5);
    if (times < 1) {
      if(times == ""){
        return false;
      }
      times = 1;
    }
    document.getElementById("inputValue"+index).value = times;
    onChange(id, times, num, rate)
  }

  // 点击变更
  handleClick(type,index) {
    const { onChange, id, num, rate} = this.props;
    let result = document.getElementById("inputValue"+index).value;
    if (type == '-' && result == 1) {
      return;
    }
    if (type == '-') {
      result--;
    }
    if (type == '+') {
      result++;
    }
   document.getElementById("inputValue"+index).value = result;
    onChange(id, result, num, rate)
  }

  // 失去焦点
  handleOnBlur(index) {
    const { onChange, id, num, rate} = this.props;
    let times = document.getElementById("inputValue"+index).value.replace(/[^0-9]/g,"").substring(0,5);
    if(times==""){
      times = 1
    }
    document.getElementById("inputValue"+index).value = times
    onChange(id, times, num, rate)
  }

  render() {
    const { value, index, id} = this.props;
    return (
      <div className='select-times orderSelectTimes' key = {id}>
        <div className="multipleCon fl relative">
          <span onClick={this.handleClick.bind(this, '-', index)} className="reduce">-</span>
          <input maxLength="5" type="number" id = {'inputValue' + index} onChange={this.handleOnchange.bind(this, index)} onBlur={this.handleOnBlur.bind(this, index)} defaultValue={value||1}></input>
          <span onClick={this.handleClick.bind(this, '+', index)} className="add">+</span>
        </div>
      </div>
    );
  }
}
